import React, { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';  // Importar QRCodeCanvas en lugar de QRCode
import html2canvas from 'html2canvas';
import Modal from 'react-modal';
import Logo from '../images/Logo.png';
Modal.setAppElement('#root');

const QRCodeGenerator = ({ isOpen, onClose, userName, espacio, reservationDate, startTime, endTime }) => {
  const [qrData, setQrData] = useState('');

  const generateQRCodeData = () => {
    const uniqueData = `${espacio} - Espacio Reservado por ${userName} para el ${reservationDate} de ${startTime} a ${endTime}`;

    setQrData(JSON.stringify(uniqueData)); 
  };

  const downloadQRCodeAsImage = () => {
    const qrElement = document.getElementById('qrCode');

    html2canvas(qrElement).then((canvas) => {
      const imgUrl = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = imgUrl;
      link.download = `Qr-code-Reserva-${userName}.png`;
      link.click();
    });
  };

  React.useEffect(() => {
    if (isOpen) {
      generateQRCodeData();
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Generar QR"
      className="modal-content"
    >
      <h2>QR de la Reserva</h2>
      <div id="qrCode">
        {/* Usamos QRCodeCanvas en lugar de QRCode */}
        <QRCodeCanvas
          value={qrData}
          size={256}
          level="H"
          includeMargin={true}
          renderAs="png"
          fgColor="#000000"
          bgColor="#ffffff"
          imageSettings={{
            src: Logo,
            x: undefined,
            y: undefined,
            height: 80,
            width: 80,
            excavate: true,
          }}
        />
      </div>
      <button onClick={downloadQRCodeAsImage}>Descargar QR</button>
      <button onClick={onClose}>Cerrar</button>
    </Modal>
  );
};

export default QRCodeGenerator;
